import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import { url } from "aldoo-ra/CMS/url"
import MenuGroup from "aldoo-ra/MenuGroup"
import PubSub from "pubsub-js"
import DynamicSVG from "aldoo-ra/DynamicSVG"
import parse from "html-react-parser"

const FooterDesktop = () => {
  return (
    <div className="w-full bg-footer px-[16px] md:px-px1_l xl:px-px1_xl">
      <div className="flex flex-col lg:max-w-w1_l xl:max-w-w1_xl items-center mx-auto">
        {/* Content Above Divider */}
        <div className="flex flex-row items-start justify-between w-full pt-[80px] pb-20 mx-auto">
          {/* Logo and Heading */}
          <MenuGroup
            name="Footer Logo & CTA Group"
            renderAs="vlist"
            styleOverrides={{ menu_column: "hidden" }}
            // itemWidth="240px"
            menuItemRender={(item) => {
              return (
                <div className="max-w-[380px] mt-[-40px]">
                  <img src={url(item.image)} className="w-[211px]" />

                  <Typography variant="h2" className="text-text text-wrap mt-[20px]">
                    {item.description && typeof item.description === 'string' ? parse(item.description) : item.description}
                  </Typography>
                </div>
              )
            }}
          />

          {/* 3 Menu Columns */}
          <div className="flex items-start justify-end md:gap-[80px] xl:gap-[110px] pr-[40px]">
            {/* Oxford Dictionary */}
            <MenuGroup
              renderAs={"vlist"}
              name="Footer Oxford Dictionary Group"
              styleOverrides={{ 
                menu_column: "hidden",
                menu_item: "px-0 my-4" 
              }}
              rootItemRender={(item) => {
                return (
                  <Typography 
                    variant="body1_accent" 
                    className="mt-[0px] mb-[-10px]"
                  >
                    {item.label}
                  </Typography>
                )
              }}
              menuItemRender={(item) => {
                return <Button variant="nav_menuitem">{item.label}</Button>
              }}
            />

            {/* Products */}
            <MenuGroup
              renderAs={"vlist"}
              name="Footer Products Group"
              styleOverrides={{ 
                menu_column: "hidden",
                menu_item: "px-0 my-4" 
              }}

              rootItemRender={(item) => {
                return (
                  <Typography 
                    variant="body1_accent" 
                    className="mt-[0px] mb-[-10px]"
                  >
                    {item.label}
                  </Typography>
                )
              }}
              menuItemRender={(item) => {
                return <Button variant="nav_menuitem">{item.label}</Button>
              }}
            />

            {/* Others */}
            <MenuGroup
              renderAs={"vlist"}
              name="Footer Others Group"
              styleOverrides={{ 
                menu_column: "hidden",
                menu_item: "px-0 my-4" 
              }}
              /* styleOverrides={{
                menu_item: "hover:animate-bounce duration-1000",
              }} */
              actionMap={{
                "open-contacts": (item) => {                  
                  PubSub.publish("open-contacts")
                },
              }}
              rootItemRender={(item) => {
                return (
                  <Typography 
                    variant="body1_accent" 
                    className="mt-[0px] mb-[-10px]"
                  >
                    {item.label}
                  </Typography>
                )
              }}
              menuItemRender={(item) => {
                return <Button variant="nav_menuitem">{item.label}</Button>
              }}
            />
          </div>
        </div>

        {/* Contend Below Divider */}
        <div className="flex flex-col lg:flex-row items-center justify-between w-full max-w-[1520px] h-[105px] border-t border-bordered mx-auto">
          {/* Copyright group - hlist on md, lg, xl screens */}
          <MenuGroup 
            name="Footer Copyright Group" 
            renderAs="hlist"
            styleOverrides={{ 
              menu: "hidden md:flex flex-row items-center md:gap-1 xl:gap-2 mt-10 lg:my-0",
              menu_item: "flex items-center justify-start list-none px-0 py-0 my-0 mr-5 rounded-md text-text"
            }}
            
            menuItemRender={(item) => {
              if (item.link) {
                return <Button variant="nav_menuitem" className="lg:!text-[14px] xl:!text-[15px] !text-left whitespace-nowrap">{item.label}</Button>;
              }
              return  <Typography 
                        variant="txt1"
                        className="lg:!text-[14px] xl:!text-[15px] whitespace-nowrap"
                      >
                        {item.label}
                      </Typography>;
            }}
          />

          {/* Follow us - social links menu */}
          <div className="flex items-center justify-end w-full">
            <MenuGroup
              name="social-oxford_dictionary"
              renderAs="hlist"
              variant="mobilingo_hlist_follow"
              menuItemRender={(item) => {
                return (
                  <div className="flex items-center">
                    {item.image && (
                      <DynamicSVG 
                        url={item.image}
                        className="lg:w-5 xl:w-6 lg:h-5 xl:h-6 text-text hover:text-primary transition duration-200"
                      />
                    )}

                    {!item.image && (
                      <Typography 
                        variant="txt1"
                        className="lg:!text-[14px] xl:!text-[15px] text-text whitespace-nowrap mr-2">
                        {item.label}
                      </Typography>
                    )}
                  </div>
                )
              }}
            />

            <MenuGroup
              name="social-TT"
              renderAs="hlist"
              variant="mobilingo_hlist_follow"
              menuItemRender={(item) => {
                return (
                  <div className="flex items-center">
                    {item.image && (
                      <DynamicSVG 
                        url={item.image}
                        className="lg:w-5 xl:w-6 lg:h-5 xl:h-6 text-text hover:text-primary transition duration-200"
                      />
                    )}

                    {!item.image && (
                      <Typography 
                        variant="txt1"
                        className="lg:!text-[14px] xl:!text-[15px] text-text whitespace-nowrap mr-2">
                        {item.label}
                      </Typography>
                    )}
                  </div>
                )
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterDesktop
